import { useContext } from 'react';

import AppContext from '@/contexts/appContext';
import { createRepository } from '@/repositories/GenericRepository';
import { QueryParams } from '@/types/query';
import { Substance } from '@/types/substance';

const basePath = '/api/program/substances';

export const substanceRepository = createRepository<Substance, Substance>(basePath);

const SubstanceRepository = () => {
  const { host } = useContext(AppContext);

  return {
    async list(params: QueryParams = {}) {
      return substanceRepository.listNoPagination({ host, params });
    }
  };
};

export default SubstanceRepository;
